module.exports = __webpack_public_path__ + "img/preview.78baf652.png";